import definitions from './banks/dystopiaBank.json';
import { createDefaultInstrumentPatch, normalizeInstrumentPatch } from './patchSchema';

// Native interpretations, with explicit per-patch conversion limits and provenance.
export const DYSTOPIA_PRESETS = definitions.map(definition => {
  const base = createDefaultInstrumentPatch();
  return normalizeInstrumentPatch({ ...base, ...definition,
    macros: { Punch: 0.25, Metal: 0, Dirt: 0, Width: 0.25, Motion: 0, Air: 0, Body: 0.35, Space: 0 },
    layers: base.layers.map((layer,i) => ({ ...layer, enabled: false, level: 0,
      detune: 0, width: 0, unison: 1, envelope: { ...layer.envelope, enabled: false }, ...definition.layers[i] })),
    filter2: { ...base.filter2, enabled: false },
    filterEnvelope: { ...base.filterEnvelope, amount: 0, ...definition.filterEnvelope },
    lfo: { ...base.lfo, ...definition.lfo }, lfo2: { ...base.lfo2, enabled: false },
    stepMod: { ...base.stepMod, enabled: false },
    arp: { ...base.arp, enabled: false, ...definition.arp },
    performance: { ...base.performance, ...definition.performance },
    effects: Object.fromEntries(Object.entries(base.effects).map(([key,value]) => [key, {
      ...value, enabled: false, ...definition.effects[key]
    }]))
  });
});
